import { render, staticRenderFns } from "./task_newbie.vue?vue&type=template&id=5aed3604&scoped=true"
import script from "./task_newbie.vue?vue&type=script&lang=ts"
export * from "./task_newbie.vue?vue&type=script&lang=ts"
import style0 from "./task_newbie.vue?vue&type=style&index=0&id=5aed3604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aed3604",
  null
  
)

export default component.exports